const config = BJY.config;
export const userRoleMap = {
  [config.ROLE_TYPE_TEACHER]: {
    en: 'teacher',
    cn: '老师',
  },
  [config.ROLE_TYPE_ASSISTANT]: {
    en: 'assistant',
    cn: '助教',
  },
  [config.ROLE_TYPE_STUDENT]: {
    en: 'student',
    cn: '学生',
  },
  [config.ROLE_TYPE_GUEST]: {
    en: 'guest',
    cn: '游客',
  },
};
